import RecordsWithParams from "../model/RecordsWithParams";
import OfferMediumsDao from "../infrastructure/dao/OfferMediumsDao";
import { OfferMedium } from "../model/OfferMedium";
import { NumberishId } from "../model/type";
import { DataQueryParamsInterface } from "../model/DataQueryParams";
import { OfferCreatorFilterParams } from "../model/filter-params/OfferCreatorFilterParams";

const getOfferMediums = (dao: OfferMediumsDao): GetOfferMediums<true> => (offerId, dataQueryParams) => {
    return dao.findAll(offerId, dataQueryParams);
}
export default getOfferMediums;

export type GetOfferMediums<UseOfferId extends boolean = false> =
    UseOfferId extends true
        ? (offerId: NumberishId, dataQueryParams: DataQueryParamsInterface<OfferCreatorFilterParams>) => Promise<RecordsWithParams<OfferMedium>>
        : (dataQueryParams: DataQueryParamsInterface) => Promise<RecordsWithParams<OfferMedium>>